import { render } from "./SecondarySiteNav.vue?vue&type=template&id=16c89f45"
import script from "./SecondarySiteNav.vue?vue&type=script&lang=js"
export * from "./SecondarySiteNav.vue?vue&type=script&lang=js"

import exportComponent from "/tmp/build/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__